/**
 * Get the router basename based on the current location
 * For module-based deployment, returns the module name (e.g., '/visit-view', '/visit-notification')
 * For root deployment, returns empty string
 */
export const getRouterBasename = (): string => {
  const KNOWN_MODULES = [
    'visit-notification',
    'visit-view',
    'port-call',
    'hydrometeo',
    'community-admin',
    'organization-admin',
    'configuration',
    'landing-page',
  ];

  // Get the pathname from the window
  const pathname = window.location.pathname;

  // Extract potential module name from path
  // e.g., '/visit-notification/dashboard' -> 'visit-notification'
  const segments = pathname.split('/').filter(Boolean);

  if (segments.length > 0) {
    const firstSegment = segments[0];

    // If first segment matches a known module, use it as basename
    if (KNOWN_MODULES.includes(firstSegment)) {
      return `/${firstSegment}`;
    }
  }

  // If no module path found, return empty basename for root deployment
  return '';
};
